import React from "react";
import { Container } from "react-bootstrap";
import ButtonText from "../components/ButtonText";
import WpImage from "../components/WpImage";
import { VectorBackground } from "../components/VectorBackground";
import HeroAnimation from "../components/HeroAnimation";
import HeroLogos from "../components/HeroLogos";

const Hero = ({
    category,
    header,
    secondHeader,
    text,
    image,
    buttons,
    className,
    hideBadges,
    animatedBackground,
    logosLabel,
    logos,
}) => {
    const hasLogos = logos?.some(({ image }) => !!image);

    return (
        <section
            className={[
                "hero",
                animatedBackground && "-animated",
                hasLogos && "-with-logos",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <VectorBackground hideTopLine={false} />
            {animatedBackground && <HeroAnimation />}

            <Container className="hero__grid-container">
                {(category || header) && (
                    <div className="hero__heading">
                        {category && (
                            <p
                                className="hero__label"
                                dangerouslySetInnerHTML={{ __html: category }}
                            />
                        )}
                        {header && (
                            <h1
                                className="hero__header"
                                dangerouslySetInnerHTML={{ __html: header }}
                            />
                        )}
                    </div>
                )}

                <div className="hero__text-column">
                    {secondHeader && (
                        <p
                            className="hero__subtitle"
                            dangerouslySetInnerHTML={{ __html: secondHeader }}
                        />
                    )}
                    {text && (
                        <div
                            className="hero__text"
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    )}

                    {buttons && (
                        <div className="hero__button-container">
                            {buttons
                                .filter(({ button }) => !!button?.link)
                                .map(({ button }, index) => (
                                    <ButtonText
                                        key={index}
                                        className="hero__button"
                                        variant={`${button.variant}`}
                                        {...button.link}
                                    >
                                        {button.link.title}
                                    </ButtonText>
                                ))}
                        </div>
                    )}
                </div>

                {image && (
                    <div className="hero__visuals-column">
                        <div className="hero__image-wrapper">
                            <WpImage
                                image={image}
                                alt={
                                    header
                                        ? header.replace(/<[^>]*>?/gm, "")
                                        : "Wyden Platform Interface"
                                }
                                className="hero__main-image"
                            />

                            {!hideBadges && (
                                <div className="hero__badges-layer">
                                    <div className="hero__floating-badge hero__floating-badge--sol" />
                                    <div className="hero__floating-badge hero__floating-badge--btc" />
                                    <div className="hero__floating-badge hero__floating-badge--usdc" />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Container>

            <HeroLogos label={logosLabel} logos={logos} />
        </section>
    );
};

export default Hero;
